/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientRoleViewModel } from '../../models/client-role-view-model';

export interface GetClientRoles$Params {
  clientID: number;
      body?: {
'prefixText'?: string;
'count'?: number;
}
}

export function GetClientRoles(http: HttpClient, rootUrl: string, params: GetClientRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientRoleViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetClientRoles.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientRoleViewModel>>;
    })
  );
}

GetClientRoles.PATH = '/api/Clients/GetClientRoles/{clientID}';
